var map = {
	"./Activities.png": "vmH1",
	"./Art.png": "vfb1",
	"./Beach.png": "f8jQ",
	"./Bike Tours.png": "BWdT",
	"./Boat Tours.png": "jlcx",
	"./Bridge.png": "8DL9",
	"./Bus.png": "gV+i",
	"./BusStop.png": "g6iq",
	"./Campsite.png": "Ymia",
	"./Cycling.png": "uKhq",
	"./Drinking & Nightlife.png": "Hy5q",
	"./Eating.png": "j2Tm",
	"./Entertainment.png": "C1Lz",
	"./Ferry.png": "8BL5",
	"./For Kids.png": "UCVK",
	"./Forest.png": "sFjY",
	"./Gallery.png": "Dlgy",
	"./Museum.png": "7ytl",
	"./Nature.png": "UsKw",
	"./POI.png": "kGX/",
	"./Parking.png": "cW9R",
	"./Pick-up point.png": "1p/w",
	"./Pickup-point.png": "XWeR",
	"./Playground.png": "KaQF",
	"./Port.png": "0cOx",
	"./Restroom.png": "w+P2",
	"./Service Provider.png": "PtUY",
	"./Shopping.png": "2+Qj",
	"./Sight.png": "snB6",
	"./Sights.png": "7B5j",
	"./Sleeping.png": "xSG2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GlQu";